


















import '@fortawesome/fontawesome-free/css/all.min.css';
import { Component, Vue } from 'vue-property-decorator';

import SideBar from '@/components/navigations/SideBar.vue';
import { fetchSportData } from '@/services/TournamentService';
import TopNavBar from '@/components/navigations/TopNavBar.vue';

@Component({
  components: { SideBar, TopNavBar }
})
export default class App extends Vue {
  public showSideBar: boolean = false;
  public selectedSport: string|null = null;

  public showHideSideBar(show: boolean = false) {
    this.showSideBar = show;
  }

  public updateSelectedSport(sport: string) {
    this.selectedSport = sport && sport.length ? sport : '';
  }

  get sideBarClassObject() {
    if (!this.showSideBar) {
      return {
        'slide-out': true
      };
    }

    return {
      'slide-in': true
    };
  }
}
